import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { EmailTemplateFilterDetails } from "../types/emailTemplateTypes";

export const emailTemplateFilterInitialValues: EmailTemplateFilterDetails = {
  name: "",
  nameEn: "",
  subject: "",
  text: "",
  createdDateFrom: undefined,
  createdDateTo: undefined,
  lastUpdateDateFrom: undefined,
  lastUpdateDateTo: undefined,
  isHtml: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "createdDate",
};
